'use client';

import { VARIANT } from '@/constants';
import { LinkButton as CommonLinkButton } from '@monorepo/common';
import type { LinkButtonProps } from '@monorepo/common';

function LinkButton<T extends string>({ color, bgColor, outlined, ...props }: Omit<LinkButtonProps<T>, 'variant'>) {
  return <CommonLinkButton variant={VARIANT} color={color} bgColor={bgColor} outlined={outlined} {...props} />;
}

export default LinkButton;
